import { render, staticRenderFns } from "./Detain.vue?vue&type=template&id=2767f988&"
import script from "./Detain.vue?vue&type=script&lang=js&"
export * from "./Detain.vue?vue&type=script&lang=js&"
import style0 from "./Detain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports